import {gql, useMutation} from '@apollo/client';
import type {MutationHookOptions} from '@apollo/client';
import type {
  UpdateStaffMutation,
  UpdateStaffMutationVariables,
} from '../types/graphql';

/**
 * Mutation to update state of staff member.
 */
export const UPDATE_STAFF = gql`
  mutation UpdateStaff($id: ID!, $isActive: Boolean!, $roles: [Role!]!) {
    updateStaff(data: {id: $id, isActive: $isActive, roles: $roles}) {
      id
      isActive
      roles
    }
  }
`;

/**
 * Hook to update a staff person.
 */
export const useUpdateStaff = (
  opts?: MutationHookOptions<UpdateStaffMutation, UpdateStaffMutationVariables>,
) =>
  useMutation<UpdateStaffMutation, UpdateStaffMutationVariables>(
    UPDATE_STAFF,
    opts,
  );
